import IssueItem from "./IssueItem";

function CommonIssuesList({ issues }) {
  return (
    <div className="ai-results h-100">
      {issues.map((issue, index) => (
        <IssueItem key={index} issue={issue} index={index} />
      ))}
    </div>
  );
}

export default CommonIssuesList;
